const ArrowDown = props => (
  <svg viewBox="0 0 9 5" {...props}>
    <path d="M0 0h9L4.5 5z" fill="currentColor" fillRule="evenodd" />
  </svg>
);
export default ArrowDown;
